// removed by extract-text-webpack-plugin
module.exports = {"cookies":"_3geCL81wB6k-Zyg3jRxU7-"};


//////////////////
// WEBPACK FOOTER
// ./components/CookieBar.scss
// module id = 1580
// module chunks = 0